export const resetPageScroll = ({
  windowObject = globalThis.window,
  documentObject = globalThis.document
} = {}) => {
  if (!windowObject?.scrollTo) return;

  documentObject?.activeElement?.blur?.();
  const applyReset = () => windowObject.scrollTo({ top: 0, left: 0, behavior: "auto" });
  const requestFrame = typeof windowObject.requestAnimationFrame === "function"
    ? windowObject.requestAnimationFrame.bind(windowObject)
    : (callback) => callback();

  applyReset();
  requestFrame(() => {
    applyReset();
    requestFrame(applyReset);
  });
};
